import React from 'react'
import { FirestoreCollection } from 'react-firestore'
// import { Route } from 'react-router-dom'

import PageLoading from '../misc/PageLoading'
import Error from '../misc/Error'
import UpsellWell from './UpsellWell'
import PersonListItemSwitch from './PersonListItemSwitch'
import PersonListQuizes from './PersonListQuizes'
import classifyPerson from '../../actions/classifyPerson'
import FireflySubscription from '../misc/FireflySubscription'
import {
  YellowWell,
} from '../../styles/wells'
import {
  AddLink,
} from '../../styles/links'

const PersonList = ({auth}) => (
  <div>
    <AddLink to="/person/add">
      <ion-icon name="add"></ion-icon>
    </AddLink>

    <FirestoreCollection
      path={'people'}
      filter={['createdBy', '==', auth.uid]}
    >
      { ({error, isLoading, data}) => {

        if (error) {
          return <Error error={error} />
        }

        if (isLoading) {
          return <PageLoading />
        }

        if (data.length === 0) {
          return <div>
            <br />
            <h1>Welcome to Heartstrings :)</h1>
            <p>Tap the "+" button below to set up your first reminder</p>
            <br />
            <br />
          </div>
        }

        const people = data
          .map(classifyPerson)
          // .sort( (a,b) => !a.nextTouch || !b.nextTouch ? 0 : a.nextTouch.getTime() - b.nextTouch.getTime())
        
        // group into headers
        const readyPeople = people.filter(person => person.showAsReady).sort( (a,b) => a.nextTouch.getTime() - b.nextTouch.getTime())
        const upcomingPeople = people.filter(person => person.showAsUpcoming).sort( (a,b) => a.nextTouch.getTime() - b.nextTouch.getTime())
        const needsInfoPeople = people.filter(person => person.showAsNeedsInfo)
        
        return <div>

          <PersonListQuizes people={needsInfoPeople} />

          {
            readyPeople.length > 0 ?
            readyPeople.map(person => <PersonListItemSwitch key={person.id} person={person} />) :
            <YellowWell style={{textAlign: 'center', padding: '3rem',}}>
              <span role="img" aria-label="heart" style={{fontSize: '80px'}}>💛</span>
              All caught up!
            </YellowWell>
          }

          {needsInfoPeople.length > 0 && <h2 className="small-text">Needs Info</h2>}
          {needsInfoPeople.map(person => <PersonListItemSwitch key={person.id} person={person} />)}

          {upcomingPeople.length > 0 && <h2 className="small-text">Later</h2>}
          {upcomingPeople.map(person => <PersonListItemSwitch key={person.id} person={person} />)}
        </div>
      }}
    </FirestoreCollection>
    <br />
    <FireflySubscription>
      { ({isLoading, error, subscription}) => !isLoading && !error && !subscription ? <UpsellWell /> : null }
    </FireflySubscription>
  </div>
)

export default PersonList



// WEBPACK FOOTER //
// ./src/views/people/PersonList.js